import { UrlParamName } from "./index";
import { State } from "store/store-types";

/**
 * Derives URL parameters from application state
 * @param state Current application state
 * @param existingParams Optional existing URLSearchParams to modify (creates new if not provided)
 * @returns URLSearchParams with state parameters while preserving other parameters
 */
export function deriveUrlParamsFromState(
    state: Partial<State>,
    existingParams?: URLSearchParams
): URLSearchParams {
    const params = existingParams || new URLSearchParams(window.location.search);

    if (state.guests !== undefined) {
        if (state.guests) {
            params.set(UrlParamName.GUESTS, state.guests.toString());
        } else {
            params.delete(UrlParamName.GUESTS);
        }
    }

    if (state.guestsChildren !== undefined) {
        if (state.guestsChildren !== null) {
            params.set(UrlParamName.GUESTS_CHILDREN, state.guestsChildren.toString());
        } else {
            params.delete(UrlParamName.GUESTS_CHILDREN);
        }
    }

    if (state.date !== undefined) {
        if (state.date) {
            params.set(UrlParamName.DATE, state.date.format("YYYY-MM-DD"));
        } else {
            params.delete(UrlParamName.DATE);
        }
    }

    return params;
}
